import { makeStyles } from "@fluentui/react-components";

export const useStyle = makeStyles({
	content: {
		zIndex: "var(--popover-z-index)",
	},
	disabled: {
		"&button": {
			pointerEvents: "none",
		},
	},
});
